import { useCookie, computed } from "#imports";
import makeServerRequest from "@/composables/makeServerRequest";
import { APIREQUESTS } from "@/helpers/variables";

export const usePageSeo = async (page) => {
  const localStorageCookie = useCookie("localStorageCopy");
  const currentLanguage = computed(
    () => localStorageCookie?.value?.language || "ar"
  );

  try {
    const { data } = await makeServerRequest({
      url: `${APIREQUESTS.user.getSeo.url}?page=${page}`,
      includeUserToken: false,
      includeUID: false,
    });

    if (data?.value?.data) {
      const seoData = data.value.data;

      // Select the appropriate language fields
      const metaTitle =
        currentLanguage.value === "ar"
          ? seoData.meta_title_ar
          : seoData.meta_title_en;
      const metaDescription =
        currentLanguage.value === "ar"
          ? seoData.meta_description_ar
          : seoData.meta_description_en;

      return {
        title: metaTitle || "",
        description: metaDescription || "",
        keywords: seoData.meta_keywords || "",
        imageAltText: seoData.image_alt_text || "",
      };
    }
  } catch (error) {
    console.error("Error fetching SEO data:", error);
  }

  return {
    title: "",
    description: "",
    keywords: "",
    imageAltText: "",
  };
};
